export const CREATE_COMPENSATORY_LEAVE = "CREATE_COMPENSATORY_LEAVE";
export const FETCH_COMPENSATORY_LEAVES = "FETCH_COMPENSATORY_LEAVES";
export const FETCH_COMPENSATORY_LEAVE = "FETCH_COMPENSATORY_LEAVE";
export const EDIT_COMPENSATORY_LEAVE = "EDIT_COMPENSATORY_LEAVE";
export const DELETE_COMPENSATORY_LEAVE = "DELETE_COMPENSATORY_LEAVE";
